import React from "react";
import {getArtistCookie, hasAnoAccess, pageFilter} from "../data/page_data";
import {parse} from "query-string";
import axios from "axios";
import {navigate} from "@reach/router";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Loading from "../components/loading";
import CssLoader from "../components/CssLoader";
import * as ReactGA from "react-ga";
import FloatingButton from "../components/FloatingButton";

export default class PhotoDetail extends React.Component {
  constructor(props) {
    super(props);
    this.params = parse(this.props.location.search);
    this.pageData = pageFilter(this.props.artist, "../");
    this.state = {};
    this.cookie = getArtistCookie();
  }

  componentDidMount() {
    var pass = this.params.bypass == 'cms';
    if(!pass && !this.cookie) {
      if (!hasAnoAccess(this.props.artist)) {
        document.location.href = "join";
        return;
      }
    }
    axios
      .get(
        "/w/api/" +
          this.pageData.artist.id +
          "/photo-detail?code=" +
          this.params.code,
        {
          headers: {
            PortalAuth: this.cookie,
          },
        }
      )
      .then((response) => {
        var respData = response.data;
        this.setState((state) => ({ data: respData }));
      })
      .catch((error) => {
        document.location.href = "join";
      });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    return (
      <>
        <CssLoader css={this.pageData.artist.css} />
        {this.pageData.artist.floating_url && (
            <FloatingButton url={this.pageData.artist.floating_url} />
        )}
        <Navbar back="../home" data={this.pageData} title="PHOTO DETAIL" />
        {!this.state.data ? (
          <Loading />
        ) : (
          <div className="photo-full">
            <h3 className="photo-title">{this.state.data.title}</h3>
            <img className="photo-img" src={this.state.data.url} />
          </div>
        )}
        <Footer />
      </>
    );
  }
}
